<template>
	<Row>
		<Col :span="24">
			<Skeleton :paragraph="{ rows: 13 }" :title="false" :loading="licenseStore.isLoading">
				<VerticalLayout>
					<Descriptions
						bordered
						size="small"
						:column="1"
						:labelStyle="{ backgroundColor: 'white' }"
						:contentStyle="{ backgroundColor: 'white' }"
					>
						<DescriptionsItem :label="$t('license.fields.status')">
							<StatusDisplay
								:source="licenseStore.status"
								prefix="license.statusDisplay"
								:badgeDict="BADGES"
							/>
						</DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.imageId')"><NoLineBreaks>{{ licenseStore.imageId }}</NoLineBreaks></DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.expirationDate')"><DateTimeDisplay :date="licenseStore.expirationDate" /></DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.baseStationsCount')">
							<BaseStationsCountDisplay :workingCount="licenseStore.baseStationsCount" :maxCount="licenseStore.maxBaseStationsCount" />
						</DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.geoFencing')">
							<GeoFencingDisplay :geoFencing="licenseStore.geoFencing" />
						</DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.allowVrs')">
							<LicenseBooleanFeatureDisplay field="allowVrs" />
						</DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.allowPppRtk')">
							<LicenseBooleanFeatureDisplay field="allowPppRtk" />
						</DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.allowPppGp')">
							<LicenseBooleanFeatureDisplay field="allowPppGp" />
						</DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.allowExtSources')">{{ allowExtSourcesDisplay }}</DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.allowPaas')">
							<LicenseBooleanFeatureDisplay field="allowPaas" />
						</DescriptionsItem>
						<DescriptionsItem v-if="licenseStore.featureFlagBrdcm" :label="$t('license.fields.allowBrdcm')">
							<LicenseBooleanFeatureDisplay field="allowBrdcm" />
						</DescriptionsItem>
						<DescriptionsItem v-if="licenseStore.featureFlagBaselines" :label="$t('license.fields.allowBaselines')">
							<LicenseBooleanFeatureDisplay field="allowBaselines" />
						</DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.nearConnectionsLimit')"><NoLineBreaks>{{ licenseStore.nearConnectionsLimit }}</NoLineBreaks></DescriptionsItem>
						<DescriptionsItem :label="$t('license.fields.vrsConnectionsLimit')"><NoLineBreaks>{{ licenseStore.vrsConnectionsLimit }}</NoLineBreaks></DescriptionsItem>
					</Descriptions>

					<div class="button-wrapper">
						<UploadButton
							buttonType="primary"
							:label="$t('license.uploadButtonLabel')"
							action="license/upload/"
							label-visibility="always"
							:onSuccess="handleUploadSuccess"
						/>
					</div>
				</VerticalLayout>
			</Skeleton>
		</Col>
	</Row>
</template>

<script>
import { computed, onMounted } from 'vue';
import { Row, Col, Skeleton, Descriptions, DescriptionsItem } from 'ant-design-vue';

import { useLicenseStore } from '@/stores/licenseStore';

import { showErrorMessage } from '@/components/common/errorMessage';

import NoLineBreaks from '@/components/common/NoLineBreaks.vue';
import DateTimeDisplay from '@/components/common/DateTimeDisplay.vue';
import StatusDisplay from '@/components/common/StatusDisplay.vue';
import VerticalLayout from '@/components/common/VerticalLayout.vue';
import UploadButton from '@/components/common/UploadButton.vue';

import BaseStationsCountDisplay from '@/components/license/BaseStationsCountDisplay.vue';
import GeoFencingDisplay from '@/components/license/GeoFencingDisplay.vue';
import LicenseBooleanFeatureDisplay from '@/components/license/LicenseBooleanFeatureDisplay.vue';


const BADGES = {
	ok: 'success',
	alert: 'warning',
	expired: 'error',
}


export default {
	components: {
		Row, Col, Skeleton, Descriptions, DescriptionsItem,
		NoLineBreaks, DateTimeDisplay, StatusDisplay, VerticalLayout, UploadButton, BaseStationsCountDisplay, GeoFencingDisplay, LicenseBooleanFeatureDisplay,
	},
	props: ['onUpdate'],
	setup(props) {
		const licenseStore = useLicenseStore();

		const allowExtSourcesDisplay = computed(() => licenseStore.allowExtSources.map(label => label.toUpperCase()).join(', '));

		onMounted(() => licenseStore.refresh(null, true)); // withoutRedirect

		const handleUploadSuccess = response => {
			if (response.status === 'ok') {
				licenseStore.refresh(props.onUpdate, true); // withoutRedirect
			} else {
				showErrorMessage(response.errors);
			}
		};

		return {
			BADGES,
			licenseStore,
			allowExtSourcesDisplay,
			handleUploadSuccess,
		};
	},
}
</script>

<style scoped>
.button-wrapper {
	width: 150px;
	margin-inline-start: auto !important;
}
</style>
